import { render, staticRenderFns } from "./PromoFilter.vue?vue&type=template&id=fd828cd4"
import script from "./PromoFilter.vue?vue&type=script&lang=js"
export * from "./PromoFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports